$('.shopping-guide__table-of-contents--first-link.sp').on('click', function () {
  $(this).next('.shopping-guide__table-of-contents--secondary').slideToggle();
  $(this).toggleClass('is-open');
});

/* =================================================================
スムーススクロール
================================================================= */
const anchor_list = document.querySelectorAll('#MainContent a[href^="#"]');
anchor_list.forEach(anchor => {
  anchor.addEventListener('click', (e) => {
    e.preventDefault();
    let href = anchor.getAttribute('href');
    let targetElement = document.querySelector(href);

    const rect = targetElement.getBoundingClientRect().top;
    const offset = window.scrollY;
    const headerHeight = document.querySelector('header').clientHeight + 50;
    const targetPosition = rect + offset - headerHeight;
    window.scrollTo({
      top: targetPosition,
      behavior: 'smooth'
    });
  });
});

/* =================================================================
別ページからアンカーリンクへ飛んできた時
================================================================= */
window.addEventListener('load', () => {
  let hash = location.hash;
  if (hash) {
    window.scrollTo({top: 0});
    let position = document.querySelector(hash).getBoundingClientRect().top - 200;
    window.scrollTo(
      {
        top: position,
        behavior: "smooth"
      }
    )
  }
});